import { Component, Output, EventEmitter, NgZone } from '@angular/core';
import { trigger, keyframes, animate, transition, style } from '@angular/animations';

@Component({
	selector: 'app-countdown',
	templateUrl: './countdown.component.html',
	styleUrls: ['./countdown.component.scss'],
	animations: [
		trigger('zoomOut', [
			transition('* => *', animate(2000, keyframes([
				style({opacity: '1', transform: 'none', offset: 0}),
				style({opacity: '1', transform: 'scale3d(0.6, 0.6, 0.6)', offset: .65}),
				style({opacity: '0', transform: 'scale3d(0, 0, 0)', offset: .8}),
			]))),
		])
	]
})
export class CountdownComponent {
	private TIMEOUT: number = 3;

	public running: boolean = false;
	private value: number;
	public zoomState: string = "inactive";

	@Output() expired = new EventEmitter();

	constructor(
		private zone: NgZone
	) { }

	// Start the countdown and preiodically update the remaining time linked to the display.
	start(): void {
		this.running = true;
		this.zoomState = "active";
		this.value = this.TIMEOUT;
	}

	next(event): void {
		if (event.toState.includes('active')) {
			this.zone.run(() => {
				if (this.value == 0) {
					this.expired.emit();
					this.stop();
				} else {
					this.value -= 1;
					this.zoomState = 'active' + this.value;
				}
			});
		}
	}

	// Stop the countdown and hide the display.
	stop(): void {
		this.zoomState = "inactive";
		this.running = false;
	}

	// Private function intended for use with the template when calculating the classname for each digit.
	private getClass(digit): string {
		if (this.running) {
			return 'digit-' + digit;
		} else {
			return '';
		}
	}
}
